import React from "react";
import { enUS } from "date-fns/locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

export function toTimeString(datetimeString) {
  if (datetimeString) {
    const date = new Date(datetimeString);
    return date.getTime() != NaN ? format(date, "h:mm aa") : undefined;
  }
  return datetimeString;
}

export default function TimeCell({
  item,
  editingLocked,
  shouldLockCell,
  onInlineEdit,
  ignoreInlineKeys,
  itemKey,
  isValid,
  cellContent,
  shouldEmphasizeCell,
  handleInlineEdit,
}) {
  return (
    <td
      className={
        item.isPending === true
          ? "pending-item"
          : item.isActive === false
            ? "inactive-item"
            : item.status === "Cancelled"
              ? "canceled-item"
              : undefined
      }
    >
      {!shouldLockCell &&
      !editingLocked &&
      onInlineEdit &&
      ignoreInlineKeys &&
      !ignoreInlineKeys.includes(itemKey) ? (
        <DatePicker
          className={isValid ? "ak-inline-input" : "ak-inline-invalid-input"}
          selected={(cellContent && new Date(cellContent)) || null}
          onChange={(date) =>
            handleInlineEdit(
              date && new Date(date).toLocaleString("en-US"),
              item,
              itemKey,
            )
          }
          locale={enUS}
          showTimeSelect
          showTimeSelectOnly
          timeCaption="Time"
          dateFormat="h:mm aa"
          customInput={<input className="ak-custom-input" />}
        />
      ) : (
        <div
          style={{
            fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
          }}
        >
          {toTimeString(cellContent)}
        </div>
      )}
    </td>
  );
}
